import { render, staticRenderFns } from "./AcceptAllArticles.vue?vue&type=template&id=d3d39b44&scoped=true"
import script from "./AcceptAllArticles.vue?vue&type=script&lang=js"
export * from "./AcceptAllArticles.vue?vue&type=script&lang=js"
import style0 from "./AcceptAllArticles.vue?vue&type=style&index=0&id=d3d39b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d39b44",
  null
  
)

export default component.exports